// Generated by GitHub Copilot

/** How the current session was established, as reported by `/auth/user/me`. */
export type LoginMethod = 'password' | 'password_mfa' | 'sso'

/** Why a company cannot be used with the current login: it needs a second factor (`mfa`) or a single sign-on (`sso`). */
export type LockReason = 'mfa' | 'sso'

/** Whether a session made this way counts as MFA: a password plus a second factor, or a single sign-on. */
export function provesMfa(loginMethod: LoginMethod | null): boolean {
  return loginMethod === 'password_mfa' || loginMethod === 'sso'
}
